const CREDIT_CARD = "creditCard";
const WIRE_TRANSFER = "wireTransfer";

export const PaymentMethodCode = {
  creditCard: CREDIT_CARD,
  wireTransfer: WIRE_TRANSFER,
};
